import { MouseEventHandler } from 'react'
import { Button, CircularProgress, ButtonProps } from '@mui/material'
import { SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/types'

interface BasicButtonProps extends ButtonProps {
    icon?: string | OverridableComponent<SvgIconTypeMap<{}, 'svg'>>
    progress?: boolean
}

const BasicButton = ({ title, onClick, type, disabled, icon: Icon, progress, fullWidth, variant, color = 'primary', ...rest }: BasicButtonProps) => {
    return (
        <Button
            type={type}
            disabled={disabled}
            onClick={onClick}
            fullWidth={fullWidth}
            variant={variant}
            color={color}
            sx={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                minWidth: 0,
                borderRadius: '20px'
            }}
            {...rest}
        >
            {Icon &&
                (typeof Icon === 'string' ? (
                    <img src={Icon} alt={title} style={{ paddingRight: '5px' }} />
                ) : (
                    <Icon
                        sx={{
                            marginRight: '5px',
                            stroke: '#ffffff',
                            strokeWidth: '0.5px',
                            fontSize: '20px',
                            flexShrink: 0 // prevent icon from shrinking
                        }}
                    />
                ))}

            <span
                style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    flexGrow: 1,
                    minWidth: 0
                }}
            >
                {title}
            </span>

            {progress && <CircularProgress size={16} color="inherit" sx={{ marginLeft: '8px', flexShrink: 0 }} />}
        </Button>
    )
}

export default BasicButton
